<template>
  <ServiceRecordsEmptyState
    title="Ingen dokumentasjon tilgjengelig"
    subtitle="Dokumentasjon vil være tilgjengelig når tilbudet inneholder vedlagte filer eller beskrivelse."
    :header-icon-url="NoDocumentationIcon"
  />
</template>

<script setup lang="ts">
import ServiceRecordsEmptyState from "../ServiceRecordsEmptyState.vue";
import NoDocumentationIcon from "@/assets/img/document.svg";
</script>
